exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".control-label {\r\n  font-size: small;\r\n}\r\n\r\n.dropdown-menu {\r\n  max-height: 300px;\r\n  overflow-y: scroll;\r\n}\r\n\r\n.pos-edit-row:hover {\r\n  background-color: #f8f5f8;\r\n}\r\n\r\n.edit-pos-row:hover {\r\n  color: #1d1d1d;\r\n  cursor: pointer;\r\n}\r\n\r\n.filter-list {\r\n  background-color: white;\r\n  border: 1px solid #d0d0d0;\r\n  border-radius: 5px;\r\n  max-height: 350px;\r\n  overflow-y: auto;\r\n  overflow-x: auto;\r\n  width: -webkit-max-content;\r\n  width: -moz-max-content;\r\n  width: max-content;\r\n  margin-top: 5px;\r\n  width: 100%;\r\n}\r\n\r\n.no-link {\r\n  color: #000000;\r\n  text-decoration: none;\r\n\r\n  white-space: normal !important;\r\n  word-wrap: break-word;\r\n}\r\n\r\n.hover-color-item:hover {\r\n  cursor: pointer;\r\n  background-color: #e8e8e8 !important;\r\n}\r\n\r\n.hover-color-item:active {\r\n  color: #2a2a2a;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/work/new2/internal-frontend/src/app/content-page/admin/create-position/create-position.component.css
// module id = ../../../../../src/app/content-page/admin/create-position/create-position.component.css
// module chunks = main